<template>
    <div class="overview-staff-root">
        <!-- TopBar -->
        <OverviewTopBar :dataTopBar="dataoverview.infosTopBar" />

        <div class="overview-body container-big flex-row self-center wp-10">
            <!-- NAV -->
            <div class="toggle-card-container">
                <h3 class="mb-3">{{ $l10n.__('Informations') }}</h3>
                <div class="well relative">
                    <div
                        v-for="(card, indexCard) in dataoverview.infosLeftPanel.orderCards"
                        :key="indexCard"
                    >
                        <ToggleNav
                            :endpoint="dataoverview.infosLeftPanel.endpoint"
                            :controller="dataoverview.infosLeftPanel.controller"
                            :action="dataoverview.infosLeftPanel.action"
                            :cardtype="indexCard"
                            :linkedid="parseInt(dataoverview.infosLeftPanel.linkedid)"
                            :linkedtype="dataoverview.infosLeftPanel.linkedtype"
                        />
                    </div>
                </div>
            </div>

            <!-- TIMELINE -->
            <div class="timeline-container flex-column flex pl-5" style="min-height: 700px">
                <h3 class="mb-3">{{ $l10n.__('Activité') }}</h3>
                <Timeline
                    forceTab="activity"
                    :linkedid="dataoverview.timeline.linkedid"
                    :linkedtype="dataoverview.timeline.linkedtype"
                    :overviewType="dataoverview.timeline.linkedtype"
                />
            </div>
        </div>
    </div>
</template>

<script>
import Timeline from 'vcomponents/timeline/Timeline.vue';
import OverviewTopBar from './OverviewTopBar.vue';
import ToggleNav from 'vcomponents/utilities/ToggleNav.vue';

export default {
    components: {
        Timeline,
        OverviewTopBar,
        ToggleNav,
    },
    props: {
        dataoverview: {
            type: Object,
            required: true,
        },
    },
};
</script>

<style lang="scss" scoped>
@use '~@sellsy/styleguide/src/_variables' as *;

.overview-staff-root {
    display: flex;
    flex-direction: column;
    height: 100%;

    .overview-body {
        .toggle-card-container {
            display: inline-block;
            width: 272px;
            vertical-align: top;
        }
    }
}
</style>
